import React, { Suspense, useEffect } from "react";
import IframeRoutes from "@/routes/IframeRoutes";
import { FluentProvider } from "@fluentui/react-components";
import { Loader } from "components";
import { useInitialize } from "@/hooks/useInitialize";
import { getTeamsTheme } from "@/core/utils/helpers";
import CONSTANTS from "@/core/utils/constants";
import DomainSelector from "@/guard/DomainSelector/DomainSelector";
import EnvBadge from "@/components/EnvBadge/EnvBadge";
import styles from "@/App.module.css";

const App = React.memo(() => {
  const { theme, tokenReady, requiresBrowserAuth, requestBrowserAuth } =
    useInitialize();
  const [fluentTheme, globalClass] = getTeamsTheme(theme);

  useEffect(() => {
    document.body.classList.remove(...Object.values(CONSTANTS.GLOBAL_CLASSES));
    document.body.classList.add(globalClass);
  }, [globalClass]);

  return (
    <FluentProvider theme={fluentTheme}>
      <div className={`main_container ${styles.main}`}>
        <EnvBadge />
        <Suspense fallback={<Loader label="Loading application..." />}>
          <DomainSelector
            tokenReady={tokenReady}
            requiresBrowserAuth={requiresBrowserAuth}
            onRequestBrowserAuth={requestBrowserAuth}
          >
            <IframeRoutes />
          </DomainSelector>
        </Suspense>
      </div>
    </FluentProvider>
  );
});

export default App;
